// extracted by mini-css-extract-plugin
export default {"Link":"ContactsBlock_Link__313Yx","SupportPhone":"ContactsBlock_SupportPhone__gFiRJ","SocialLink":"ContactsBlock_SocialLink__CVqOw","MapImage":"ContactsBlock_MapImage__Ih49z"};